import { UrlUtils } from "./UrlUtils";
var ModuleVersion = /** @class */ (function () {
    function ModuleVersion() {
        var _this = this;
        this.moduleName = __MODULE_NAME__;
        this.packageJsonVersion = __PACKAGE_JSON_VERSION__;
        this.jenkinsBuildVersion = __JENKINS_BUILD_VERSION__;
        this.gitCommit = __GIT_COMMIT__;
        this.gitTag = __GIT_TAG__;
        this.dependencies = __MODULE_DEPENDENCIES__;
        this.infoNormalizeLength = 14;
        this.dependenciesNormalizeLength = 0;
        if (Array.isArray(this.dependencies)) {
            this.dependencies.forEach(function (item) {
                return _this.dependenciesNormalizeLength = Math.max(_this.dependenciesNormalizeLength, item.name.length + 2);
            });
        }
    }
    ModuleVersion.prototype.log = function () {
        var _this = this;
        var _a;
        if (UrlUtils.getUrlParam(ModuleVersion.ENABLE_FROM_URL) === "1" || __DEV__) {
            console.group("%c Version ", "color: white; background-color: #256e1b", this.moduleName);
            console.log(this.normalizeName("package.json:", this.infoNormalizeLength), this.packageJsonVersion);
            console.log(this.normalizeName("jenkins build:", this.infoNormalizeLength), this.jenkinsBuildVersion);
            console.log(this.normalizeName("git commit:", this.infoNormalizeLength), (_a = this.gitCommit) === null || _a === void 0 ? void 0 : _a.substr(0, 11));
            console.log(this.normalizeName("git tag:", this.infoNormalizeLength), this.gitTag);
            console.groupCollapsed("dependencies: ");
            if (Array.isArray(this.dependencies)) {
                this.dependencies.forEach(function (item) {
                    return console.log(_this.normalizeName(item.name + ":", _this.dependenciesNormalizeLength), item.version);
                });
            }
            console.groupEnd();
            console.groupEnd();
        }
    };
    ModuleVersion.prototype.normalizeName = function (name, length) {
        var result = name;
        var diff = length - name.length;
        if (diff > 0) {
            result = result + " ".repeat(diff);
        }
        return result;
    };
    ModuleVersion.ENABLE_FROM_URL = "showPhantomVersions";
    return ModuleVersion;
}());
export { ModuleVersion };
